import styled from "@emotion/styled";
import { IStyledComponentProps } from "../../theme/theme.types";
import { Row } from "react-bootstrap";

const FooterGradient = styled.div<IStyledComponentProps>`
  /* background: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 0.6) 100%
  ); */
  height: 255px;
  position: absolute;
  bottom: 0;
  width: 100%;
  z-index: 100;
`;

const FooterDivider = styled.div<IStyledComponentProps>`
  &.ce-CSSO-footer-divider {
    height: 10px;
    position: absolute;
    width: 100%;
    z-index: 101;
    background-color: #0079c1;
  }
`;

const FooterContentDesktop = styled.div<IStyledComponentProps>`
  &.ce-CSSO-footer-content {
    padding: 24px 0px 15px 72px;
    border-top: 12px ${(props) => props.theme?.colors?.brand.primary};
  }
`;

const FooterContentTablet = styled.div<IStyledComponentProps>`
  &.ce-CSSO-footer-content {
    padding: 24px 0px 15px 24px;
    border-top: 12px ${(props) => props.theme?.colors?.brand.primary};
  }
`;

const FooterContentMobile = styled.div<IStyledComponentProps>`
  &.ce-CSSO-footer-content {
    padding: 24px 0px 15px 0px;
    border-top: 12px ${(props) => props.theme?.colors?.brand.primary};
  }
`;

const StyledFooterCEText = styled(Row)<IStyledComponentProps>`
  margin-bottom: 5px;
  margin-left: 0px;
  color: grey;
`;

const BarlessLink = styled.a<IStyledComponentProps>`
  text-decoration: none;
`;

export default {
  FooterContentDesktop,
  FooterContentTablet,
  FooterContentMobile,
  FooterGradient,
  FooterDivider,
  StyledFooterCEText,
  BarlessLink,
};
